import React, { Fragment, useEffect, useState } from 'react';
import {
  Button,
  Col,
  Collapse,
  DatePicker,
  Input,
  Modal,
  Popover,
  Row,
  Table,
  Tabs,
  Tag,
  Upload,
} from 'antd';
import { Badge, Space, Switch } from 'antd';
import {
  EyeOutlined,
  DeleteOutlined,
  DownloadOutlined,
  DownCircleOutlined,
} from '@ant-design/icons';
import {
  UploadOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileZipOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import GuarantorDetails from './GuarantorDetails';
import LoanSwitchBox from './LoanSwitchBox';
import LoanCaseData from './LoanCaseData';
import moment from 'moment';
import {
  downloadApplications,
  objToArray,
  downloadDocuments,
  downloadDocumentsUnzip,
  handleDownload,
} from '../../common/Utilities';
import { IMAGE_BASE_URL } from '../../common/Constants';
import NotificationCarousel from './NotificationCarousel';
import DocumentPreview from './DocumentPreview';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import axios from '../../axios/axios';
import { ServerAPI } from '../../common/ServerAPI';
import { ReactComponent as CircleArrow } from '../../images/circle-arrow.svg';
import { useSelector } from 'react-redux';

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
const CaseTabDetails = ({
  type,
  data,
  reloadData,
  pagePermission,
  tabChange,
  isDibursed
}) => {
  const navigate = useNavigate();
  const [settings, setSettings] = useState({});
  const [showMore, setShowMore] = useState(false);
  const [disbDate, setDisbDate] = useState('');
  const [disbRemark, setDisbRemark] = useState('');
  const [loanTabDetails, setLoanTabDetails] = useState([]);
  const [loanDetailName, setLoanDetailName] = useState('');
  const [selectedGuarantorTab, setSelectedGuarantorTab] = useState(1);
  const [documentPreview, setDocumentPreview] = useState(false);
  const [documentUrl, setDocumentUrl] = useState('');
  const [fileDocumentType, setFileDocumentType] = useState('');
  const [downloadPopOver, setDownloadPopOver] = useState(false);
  const [disErrors, setDisbErrors] = useState({
    date_disb: false,
  });
  const [disEditMode, setDisEditMode] = useState(false);
  const handleOpenChange = (newOpen) => {
    setDownloadPopOver(newOpen);
  };
  const [fileList, setFileList] = useState([]);
  const [defaultList, setDefaultList] = useState([]);
  let imageUrlsValues = [];
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [previewType, setPreviewType] = useState('');
  const iconMap = {
    pdf: <FilePdfOutlined />,
    docx: <FileWordOutlined />,
  };
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    const extension = file.name.split('.').pop().toLowerCase();
    //console.log(extension);
    if (extension === 'pdf' || extension === 'doc' || extension === 'docx') {
      setPreviewType('doc');
    } else {
      setPreviewType('img');
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
    );
  };
  const getIcon = (file) => {
    if (file.name) {
      const extension = file.name.split('.').pop().toLowerCase();
      ////.log(extension);
      return iconMap[extension];
    }
  };
  const onImageChange = ({ fileList }) => {
    setFileList(fileList);
  };
  const onRemoveRequest = (file) => {
    setDefaultList((prevDefaultList) => {
      const updatedDefaultList = prevDefaultList.filter(
        (image) => image.name !== file.name
      );
      return updatedDefaultList;
    });
    localStorage.removeItem('agent_disbursement_ack_doc');
  };
  const customUploadRequest = async ({ file, onSuccess, onError }) => {
    try {
      const response = await ServerAPI.fileUpload(file);
      if (response.resp_code == 200) {
        const parsedValues = {};
        parsedValues['agent_disbursement_ack_doc'] = [
          {
            name: file.name,
            value: response.data,
          },
        ];
        setDefaultList(parsedValues['agent_disbursement_ack_doc']);
        localStorage.setItem(
          'agent_disbursement_ack_doc',
          JSON.stringify(parsedValues['agent_disbursement_ack_doc'])
        );
        onSuccess();
      }
      //.log(response);
    } catch (error) {
      onError(error);
    }
  };
  const uploadProps = {
    iconRender: (file, listType) => {
      return getIcon(file);
    },
  };
  let dataDocuments = [];
  let withStatusUpdate = [];
  let withoutStatusUpdate = [];
  let guaranRemoved = [];
  if (type == 'vehicle') {
    dataDocuments = objToArray(data.vehicle_documents);
  } else if (type == 'applicant') {
    dataDocuments = objToArray(data.applicant_docs);
  } else if (type == 'guarantor') {
    if (data.guarantor_details != undefined) {
      withStatusUpdate = data?.guarantor_details.filter(
        (item) => item.guarantor_status_update != null
      );
      withoutStatusUpdate = data?.guarantor_details.filter(
        (item) => item.guarantor_status_update == null
      );
    }
    if (data?.deleted_guarantors) {
      guaranRemoved = data?.deleted_guarantors;
    }
  } else if (type == 'disbursement') {
    if (data.disbursementinfo) {
      dataDocuments = [
        {
          transaction_history: data?.disbursementinfo?.transaction_history,
        },
        {
          vehicle_information: data?.disbursementinfo?.vehicle_information,
        },
        {
          vehicle_acknowledgement:
            data?.disbursementinfo?.vehicle_acknowledgement,
        },
        {
          insurance_certificate: data?.disbursementinfo?.insurance_certificate,
        },
        {
          number_retention_letter:
            data?.disbursementinfo?.number_retention_letter,
        },
      ];
    }
  }

  const fileType = (url) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
    const documentExtensions = ['pdf', 'doc', 'docx', 'txt', 'rtf'];
    const lastDotIndex = url.lastIndexOf('.');
    if (lastDotIndex !== -1) {
      const fileExtension = url.slice(lastDotIndex + 1);
      if (imageExtensions.includes(fileExtension.toLowerCase())) {
        setFileDocumentType('Image');
      } else if (documentExtensions.includes(fileExtension.toLowerCase())) {
        setFileDocumentType('Document');
      }
    }
  };

  const GuarantorItems = [
    {
      label: (
        <span className='mr-5'>
          <Badge
            showZero
            color={selectedGuarantorTab == 1 ? '#00ae11' : '#d4d4d4'}
            count={withoutStatusUpdate.length}
            offset={[15, 8]}
          >
            Available Guarantor
          </Badge>
        </span>
      ),
      key: 1,
      children: (
        <GuarantorDetails
          guarantorType={'available'}
          data={withoutStatusUpdate}
          reloadData={reloadData}
          comp={{ setDocumentPreview, setDocumentUrl, fileType }}
          pagePermission={pagePermission}
        />
      ),
    },
    {
      label: (
        <span className='mr-5'>
          <Badge
            showZero
            color={selectedGuarantorTab == 2 ? '#ff4d4f' : '#d4d4d4'}
            count={withStatusUpdate.length}
            offset={[15, 8]}
          >
            Rejected Guarantor
          </Badge>
        </span>
      ),
      key: 2,
      children: (
        <GuarantorDetails
          guarantorType={'rejected'}
          data={withStatusUpdate}
          reloadData={reloadData}
          comp={{ setDocumentPreview, setDocumentUrl, fileType }}
          pagePermission={pagePermission}
        />
      ),
    },
    {
      label: (
        <span className='mr-5'>
          <Badge
            showZero
            color='#d4d4d4'
            count={guaranRemoved.length}
            offset={[15, 8]}
          >
            Applicant removed
          </Badge>
        </span>
      ),
      key: 3,
      children: (
        <GuarantorDetails
          guarantorType={'removed'}
          data={guaranRemoved}
          reloadData={reloadData}
          comp={{ setDocumentPreview, setDocumentUrl, fileType }}
          pagePermission={pagePermission}
        />
      ),
    },
  ];

  const panelStyle = {
    background: '#D9E7FE',
  };

  const Table = ({ title, icon, headerData, pagePermission }) => {
    //console.log('headerData', headerData, pagePermission);

    return (
      <div className='ml-[-10px]'>
        <div className='ant-accordion-header'>
          <div className='ant-accordion-header-info'>
            {icon && (
              <div className='ant-accordion-logo'>
                <img src={`${IMAGE_BASE_URL}${icon}`} alt='accordion logo' />
              </div>
            )}
            <div className='ant-accordion-info'>
              <span>{'[ ' + headerData?.scheme + ' ] '}</span>
              <h3>{title}</h3>
              <h4>{headerData.product_name}</h4>
            </div>
          </div>
          <div className='acc-header-status-block'>
            {headerData?.disbursementinfo ? (
              <div>
                <h4>Applicant’s Choice</h4>
                <p className='inline-block text-[#DBFFDE] p-[5px_10px] min-w-[110px] bg-[#27AE60] mt-1 text-center font-[600] rounded-[4px]'>
                  Selected
                </p>
              </div>
            ) : null}
            {headerData?.status != null &&
              headerData?.status.is_approved == true && (
                <div className='flex'>
                  <div>
                    <h4>Status</h4>
                    <p className='inline-block text-[#DBFFDE] p-[5px_10px] min-w-[110px] bg-[#27AE60] mt-1 text-center font-[600] rounded-[4px]'>
                      Approved
                    </p>
                  </div>
                </div>
              )}
            {headerData?.status != null &&
              headerData?.status.is_counter_offered == true && (
                <Fragment>
                  {/* <div>
                    <h4>Applicant’s Choice</h4>
                    <p className='inline-block text-[#FFECEC] p-[5px_10px] min-w-[110px] bg-[#F80707] mt-1 text-center font-[600] rounded-[4px]'>
                      Rejected
                    </p>
                  </div> */}
                  <div className='select-none'>
                    {headerData?.is_counter_offer_accepted ? (
                      <div>
                        <h4>Status</h4>
                        <p className='inline-block text-[#DBFFDE] p-[5px_10px] min-w-[110px] bg-[#27AE60] mt-1 text-center font-[600] rounded-[4px]'>
                          Offer Accepted
                        </p>
                      </div>
                    ) : (
                      <div>
                        <h4>Status</h4>
                        <p className='inline-block text-[#FFECD7] p-[5px_10px] min-w-[110px] bg-[#ED7A15] mt-1 text-center font-[600] rounded-[4px]'>
                          Counter Offer
                        </p>
                      </div>
                    )}
                  </div>
                </Fragment>
              )}
            {headerData?.status != null &&
              headerData?.status.is_rejected == true && (
                <Fragment>
                  <div className='text-center text-[#0F59F9]  min-[768px]:text-[13px] max-[768px]:text-[12px] text-center p-[0.5px] rounded mr-4 flex items-center gap-[10px] select-none'>
                    <p className='inline-block text-[#DBFFDE] p-[5px_10px] min-w-[110px] bg-[#F80707] mt-1 text-center font-[600] rounded-[4px]'>
                      Rejected
                    </p>
                  </div>
                </Fragment>
              )}
            {headerData.status == null && (
              <Fragment>
                {pagePermission?.update_permission == 1 && (
                  <Button
                    className='acc-head-btn'
                    onClick={() => {
                      navigate('/case-detail-status', {
                        state: {
                          loanData: headerData,
                          title: title,
                          icon: icon,
                        },
                      });
                    }}
                  >
                    Select
                  </Button>
                )}
              </Fragment>
            )}
          </div>
        </div>
      </div>
    );
  };

  let Loanitems = [];

  useEffect(() => {
    const savedValue = JSON.parse(
      localStorage.getItem('agent_disbursement_ack_doc')
    );
    if (savedValue) {
      let imageUrlArrays = [];
      savedValue.map((url, idx) => {
        imageUrlArrays.push({
          uid: idx + 1,
          name: url.name ? url.name : url?.split('/').pop(),
          status: 'done',
          url: url.value
            ? IMAGE_BASE_URL + '/' + url.value
            : IMAGE_BASE_URL + '/' + url,
        });
      });
      //console.log(imageUrlArrays, '))))))))))');
      setFileList(imageUrlArrays);
      setDefaultList(imageUrlArrays);
    }
    //console.log('dem');
  }, []);

  useEffect(() => {
    let loanItemsData = [];
    let LoanitemTabs = [];
    //console.log(data.products);
    //console.log(loanDetailName);
    if (data.products != undefined && data.products != null) {
      if (loanDetailName == 'All') {
        loanItemsData = [];
        if (
          data.products?.Bank != undefined &&
          data.products?.Bank.length > 0
        ) {
          let bank_data = data.products.Bank;
          bank_data.map((dataRow) => {
            loanItemsData.push({
              provider_name: dataRow.providerinfo?.name,
              provider_id: dataRow.providerinfo?.id,
              provider_icon: dataRow.providerinfo?.icon,
              products: [
                {
                  product_name: dataRow.name,
                  provider_name: dataRow.name,
                  interest: dataRow.int_rate,
                  interest_id: dataRow.activeinterest?.id,
                  product_id: dataRow.id,
                  agentcommision: dataRow.agentcommision,
                  application_product: dataRow.application_product,
                  disbursementinfo: dataRow.disbursementinfo,
                  loan_amt: parseInt(dataRow.loanamount).toFixed(0),
                  tenor: dataRow.tenure,
                  dealer_commission_percentage: dataRow.commision_percentage,
                  dealer_commission_amount:
                    parseInt(dataRow.loanamount) *
                    (parseFloat(dataRow.commision_percentage) / 100),
                  admin_fee: dataRow.adminfee,
                  mnthly_installement: dataRow.monthly_installment,
                  scheme: dataRow.schemeinfo?.name,
                  status: dataRow.agentupdatestatus,
                  parf: dataRow.parfvalue,
                  available_guarantors: data.guarantor_details.filter(
                    (item) => item.guarantor_status_update == null
                  ),
                  type: 'bank',
                  agentupdatestatus: dataRow.agentupdatestatus,
                  counterData: dataRow.counterData,
                  furnish_guarantors: dataRow.furnish_guarantors,
                  is_counter_offer_accepted: dataRow.is_counter_offer_accepted,
                  last_installment: dataRow.last_installment,
                  remarks: dataRow.remarks,
                  terms_and_conditions: dataRow.terms_and_conditions,
                },
              ],
              loan_application_id: dataRow.id,
              dealer_id: dataRow.dealer,
            });
          });
        }
        if (
          data.products?.Financial_Institution != undefined &&
          data.products?.Financial_Institution.length > 0
        ) {
          let financial_data = data.products.Financial_Institution;
          financial_data.map((dataRow) => {
            loanItemsData.push({
              provider_name: dataRow.providerinfo?.name,
              provider_id: dataRow.providerinfo?.id,
              provider_icon: dataRow.providerinfo?.icon,
              products: [
                {
                  product_name: dataRow.name,
                  provider_name: dataRow.name,
                  interest: dataRow.int_rate,
                  interest_id: dataRow.activeinterest?.id,
                  product_id: dataRow.id,
                  agentcommision: dataRow.agentcommision,
                  application_product: dataRow.application_product,
                  loan_amt: parseInt(dataRow.loanamount).toFixed(0),
                  tenor: dataRow.tenure,
                  disbursementinfo: dataRow.disbursementinfo,
                  dealer_commission_percentage: dataRow.commision_percentage,
                  dealer_commission_amount:
                    parseInt(dataRow.loanamount) *
                    (parseFloat(dataRow.commision_percentage) / 100),
                  admin_fee: dataRow.adminfee,
                  mnthly_installement: dataRow.monthly_installment,
                  scheme: dataRow.schemeinfo?.name,
                  status: dataRow.agentupdatestatus,
                  parf: dataRow.parfvalue,
                  available_guarantors: data.guarantor_details.filter(
                    (item) => item.guarantor_status_update == null
                  ),
                  type: 'financial_institution',
                  agentupdatestatus: dataRow.agentupdatestatus,
                  counterData: dataRow.counterData,
                  furnish_guarantors: dataRow.furnish_guarantors,
                  is_counter_offer_accepted: dataRow.is_counter_offer_accepted,
                  last_installment: dataRow.last_installment,
                  remarks: dataRow.remarks,
                  terms_and_conditions: dataRow.terms_and_conditions,
                },
              ],
              loan_application_id: dataRow.id,
              dealer_id: dataRow.dealer,
            });
          });
        }
        if (
          data.products?.['In-House'] != undefined &&
          data.products?.['In-House'].length > 0
        ) {
          let inhouse_data = data.products?.['In-House'];
          inhouse_data.map((dataRow) => {
            loanItemsData.push({
              provider_name: dataRow.name,
              provider_id: dataRow.id,
              provider_icon: dataRow.icon,
              products: [
                {
                  product_name: dataRow.name,
                  provider_name: dataRow.name,
                  interest: dataRow.int_rate,
                  interest_id: dataRow.activeinterest?.id,
                  product_id: dataRow.id,
                  agentcommision: dataRow.agentcommision,
                  disbursementinfo: dataRow.disbursementinfo,
                  application_product: dataRow.application_product,
                  loan_amt: parseInt(dataRow.loanamount).toFixed(0),
                  tenor: dataRow.tenure,
                  dealer_commission_percentage: dataRow.commision_percentage,
                  dealer_commission_amount:
                    parseInt(dataRow.loanamount) *
                    (parseFloat(dataRow.commision_percentage) / 100),
                  admin_fee: dataRow.adminfee,
                  mnthly_installement: dataRow.monthly_installment,
                  scheme: dataRow.schemeinfo?.name,
                  status: dataRow.agentupdatestatus,
                  parf: dataRow.parfvalue,
                  available_guarantors: data.guarantor_details.filter(
                    (item) => item.guarantor_status_update == null
                  ),
                  type: 'In-House',
                  agentupdatestatus: dataRow.agentupdatestatus,
                  counterData: dataRow.counterData,
                  furnish_guarantors: dataRow.furnish_guarantors,
                  is_counter_offer_accepted: dataRow.is_counter_offer_accepted,
                  last_installment: dataRow.last_installment,
                  remarks: dataRow.remarks,
                  terms_and_conditions: dataRow.terms_and_conditions,
                },
              ],
              loan_application_id: dataRow.id,
              dealer_id: dataRow.dealer,
            });
          });
        }
        //console.log(loanItemsData);
      } else if (loanDetailName == 'Bank') {
        loanItemsData = [];
        if (
          data.products?.Bank != undefined &&
          data.products?.Bank.length > 0
        ) {
          let bank_data = data.products.Bank;
          bank_data.map((dataRow) => {
            loanItemsData.push({
              provider_name: dataRow.providerinfo?.name,
              provider_id: dataRow.providerinfo?.id,
              provider_icon: dataRow.providerinfo?.icon,
              products: [
                {
                  product_name: dataRow.name,
                  provider_name: dataRow.name,
                  interest: dataRow.int_rate,
                  interest_id: dataRow.activeinterest?.id,
                  product_id: dataRow.id,
                  agentcommision: dataRow.agentcommision,
                  disbursementinfo: dataRow.disbursementinfo,
                  application_product: dataRow.application_product,
                  loan_amt: parseInt(dataRow.loanamount).toFixed(0),
                  tenor: dataRow.tenure,
                  dealer_commission_percentage: dataRow.commision_percentage,
                  dealer_commission_amount:
                    parseInt(dataRow.loanamount) *
                    (parseFloat(dataRow.commision_percentage) / 100),
                  admin_fee: dataRow.adminfee,
                  mnthly_installement: dataRow.monthly_installment,
                  scheme: dataRow.schemeinfo?.name,
                  status: dataRow.agentupdatestatus,
                  parf: dataRow.parfvalue,
                  available_guarantors: data.guarantor_details.filter(
                    (item) => item.guarantor_status_update == null
                  ),
                  type: 'bank',
                  agentupdatestatus: dataRow.agentupdatestatus,
                  counterData: dataRow.counterData,
                  furnish_guarantors: dataRow.furnish_guarantors,
                  is_counter_offer_accepted: dataRow.is_counter_offer_accepted,
                  last_installment: dataRow.last_installment,
                  remarks: dataRow.remarks,
                  terms_and_conditions: dataRow.terms_and_conditions,
                },
              ],
              loan_application_id: dataRow.id,
              dealer_id: dataRow.dealer,
            });
          });
        }
      } else if (loanDetailName == 'Financial_Institution') {
        loanItemsData = [];
        if (
          data.products?.Financial_Institution != undefined &&
          data.products?.Financial_Institution.length > 0
        ) {
          let financial_data = data.products.Financial_Institution;
          financial_data.map((dataRow) => {
            loanItemsData.push({
              provider_name: dataRow.providerinfo?.name,
              provider_id: dataRow.providerinfo?.id,
              provider_icon: dataRow.providerinfo?.icon,
              products: [
                {
                  product_name: dataRow.name,
                  provider_name: dataRow.name,
                  interest: dataRow.int_rate,
                  interest_id: dataRow.activeinterest?.id,
                  product_id: dataRow.id,
                  agentcommision: dataRow.agentcommision,
                  disbursementinfo: dataRow.disbursementinfo,
                  application_product: dataRow.application_product,
                  loan_amt: parseInt(dataRow.loanamount).toFixed(0),
                  tenor: dataRow.tenure,
                  dealer_commission_percentage: dataRow.commision_percentage,
                  dealer_commission_amount:
                    parseInt(dataRow.loanamount) *
                    (parseFloat(dataRow.commision_percentage) / 100),
                  admin_fee: dataRow.adminfee,
                  mnthly_installement: dataRow.monthly_installment,
                  scheme: dataRow.schemeinfo?.name,
                  status: dataRow.agentupdatestatus,
                  parf: dataRow.parfvalue,
                  available_guarantors: data.guarantor_details.filter(
                    (item) => item.guarantor_status_update == null
                  ),
                  type: 'financial_institution',
                  agentupdatestatus: dataRow.agentupdatestatus,
                  counterData: dataRow.counterData,
                  furnish_guarantors: dataRow.furnish_guarantors,
                  is_counter_offer_accepted: dataRow.is_counter_offer_accepted,
                  last_installment: dataRow.last_installment,
                  remarks: dataRow.remarks,
                  terms_and_conditions: dataRow.terms_and_conditions,
                },
              ],
              loan_application_id: dataRow.id,
              dealer_id: dataRow.dealer,
            });
          });
        }
      } else if (loanDetailName == 'In-House') {
        loanItemsData = [];
        if (
          data.products?.['In-House'] != undefined &&
          data.products?.['In-House'].length > 0
        ) {
          let inhouse_data = data.products?.['In-House'];
          inhouse_data.map((dataRow) => {
            loanItemsData.push({
              provider_name: dataRow.name,
              provider_id: dataRow.id,
              provider_icon: dataRow.icon,
              products: [
                {
                  product_name: dataRow.name,
                  provider_name: dataRow.name,
                  interest: dataRow.int_rate,
                  interest_id: dataRow.activeinterest?.id,
                  product_id: dataRow.id,
                  agentcommision: dataRow.agentcommision,
                  disbursementinfo: dataRow.disbursementinfo,
                  application_product: dataRow.application_product,
                  loan_amt: parseInt(dataRow.loanamount).toFixed(0),
                  tenor: dataRow.tenure,
                  dealer_commission_percentage: dataRow.commision_percentage,
                  dealer_commission_amount:
                    parseInt(dataRow.loanamount) *
                    (parseFloat(dataRow.commision_percentage) / 100),
                  admin_fee: dataRow.adminfee,
                  mnthly_installement: dataRow.monthly_installment,
                  scheme: dataRow.schemeinfo?.name,
                  status: dataRow.agentupdatestatus,
                  parf: dataRow.parfvalue,
                  available_guarantors: data.guarantor_details.filter(
                    (item) => item.guarantor_status_update == null
                  ),
                  type: 'In-House',
                  agentupdatestatus: dataRow.agentupdatestatus,
                  counterData: dataRow.counterData,
                  furnish_guarantors: dataRow.furnish_guarantors,
                  is_counter_offer_accepted: dataRow.is_counter_offer_accepted,
                  last_installment: dataRow.last_installment,
                  remarks: dataRow.remarks,
                  terms_and_conditions: dataRow.terms_and_conditions,
                },
              ],
              loan_application_id: dataRow.id,
              dealer_id: dataRow.dealer,
            });
          });
        }
      }
    }
    Loanitems = loanItemsData.map((data, idx) => {
      return {
        key: idx + 1,
        label: (
          <Table
            title={`Loan Application(s) for ${data.provider_name}`}
            icon={data.provider_icon}
            headerData={data.products[0]}
            pagePermission={pagePermission}
          />
        ),
        children: (
          <LoanCaseData
            dataRows={data.products}
            icon={data.provider_icon}
            title={data.provider_name}
            reloadData={reloadData}
            pagePermission={pagePermission}
            tabChange={tabChange}
          />
        ),
        style: panelStyle,
      };
    });
    setLoanTabDetails(Loanitems);
  }, [loanDetailName, data]);

  useEffect(() => {
    if (data.disbursementinfo) {
      if (
        data.disbursementinfo.disbursement_date === null ||
        data.disbursementinfo.disbursement_date === ''
      ) {
        setDisEditMode(true);
      } else {
        setDisEditMode(false);
        setDisbDate(dayjs(data.disbursementinfo.disbursement_date));
        setDisbRemark(data.disbursementinfo.remarks);
      }
    }
  }, [data]);

  useEffect(() => {
    async function GetSettings() {
      let res = await axios.get("/settings");
      setSettings(res.data?.data);
    }
    GetSettings();
  }, []);

  const ApplicantInfo = data?.applicant_details;
  const EmploymentDetails = data?.applicant_employement_details;


  const GetIDType = (id) => {
    //console.log("GETIDD", id, settings)
    const temp = settings?.ownerid_types?.filter((it) => it?.value == id);
    return temp?.length > 0 && temp !== undefined ? temp[0]?.label : "";
  };

  return (
    <div
      className='app-detail-tab-content mx-5 mt-5 bg-white p-5'
      style={{ maxHeight: '100%' }}
    >
      {type == 'vehicle' && (
        <Fragment>
          <div className="preview-details-head">
            <h1>Details</h1>
          </div>
          <div className="preview-list-block">
            <div className="preview-list-group">
              <div className="preview-list">
                <h3>Vehicle Type:</h3>
                <p>{data?.typeinfo ? data?.typeinfo?.name : "N/A"}</p>
              </div>
              <div className="preview-list">
                <h3>Vehicle Reg No:</h3>
                <p>
                  {data.vehicle_details?.vehicle_reg_no
                    ? data.vehicle_details?.vehicle_reg_no
                    : "N/A"}
                </p>
              </div>
              <div className="preview-list">
                <h3>Access Code:</h3>
                <p>{data?.vehicle_details?.access_code}</p>
              </div>
              <div className="preview-list">
                <h3>Vehicle Make/Model:</h3>
                <p>{data.vehicle_details?.make_model}</p>
              </div>
              <div className="preview-list">
                <h3>OPC:</h3>
                <p>
                  {data.vehicle_details?.is_opc_car == 1
                    ? "Yes, remains as OPC"
                    : "No"}
                </p>
              </div>
            </div>
            <div className="preview-list-group">
              <div className="preview-list">
                <h3>Y.O.M:</h3>
                <p>
                  {data.vehicle_details?.vehicle_yom
                    ? data.vehicle_details?.vehicle_yom
                    : "N/A"}
                </p>
              </div>
              <div className="preview-list">
                <h3>Purchase Price:</h3>
                <p>$ {Math.round(data?.vehicle_details?.vehicle_purchase_price)}</p>
              </div>
              <div className="preview-list">
                <h3>Selling Price:</h3>
                <p>$ {Math.round(data?.vehicle_details?.selling_price)}</p>
              </div>
              <div className="preview-list">
                <h3>OMV:</h3>
                <p>$ {Math.round(data?.vehicle_details?.vehicle_omv)}</p>
              </div>
              <div className="preview-list">
                <h3>Engine No:</h3>
                <p>{data?.vehicle_details?.vehicle_engine_no}</p>
              </div>
            </div>
            <div className="preview-list-group">
              <div className="preview-list">
                <h3>Chassis No:</h3>
                <p>{data?.vehicle_details?.vehicle_chassis_no}</p>
              </div>
              <div className="preview-list">
                <h3>Reg Date:</h3>
                <p>
                  {data?.vehicle_details?.vehicle_ori_reg_date !== "" &&
                    data?.vehicle_details?.vehicle_ori_reg_date !== null
                    ? dayjs(
                      data?.vehicle_details?.vehicle_ori_reg_date,
                      "YYYY-MM-DD"
                    ).format("DD-MM-YYYY")
                    : ""}
                </p>
              </div>
              <div className="preview-list">
                <h3> COE-QP / PQP Paid:</h3>
                <p>$ {data?.vehicle_details?.vehicle_coe_amount}</p>
              </div>
              <div className="preview-list">
                <h3> ARF Paid:</h3>
                <p>$ {Math.round(data?.vehicle_details?.arf_paid)}</p>
              </div>
              <div className="preview-list">
                <h3> Transfer count:</h3>
                <p>{data?.vehicle_details?.transfer_count}</p>
              </div>
              <div className="preview-list">
                <h3>loan To Value Percentage:</h3>
                <p>{data?.vehicle_details?.loan_to_value} %</p>
              </div>
            </div>
          </div>
          <Row gutter={[24, 0]}>
            <Col xs={24} sm={24} md={12} lg={12} className="">
              <p className="mt-5 text-[15px] font-[600]">
                Document(s) Uploaded
              </p>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} className="text-right">
              <div className="justify-between items-center mb-2">
                <Popover
                  content={
                    <div>
                      <Button
                        type="primary"
                        onClick={() => {
                          downloadDocuments(type, data.id);
                        }}
                        className="min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px] mb-2"
                      >
                        <FileZipOutlined className="mr-2 mt-1" />
                        <p>Download Zip</p>
                      </Button>
                      <Button
                        type="primary"
                        onClick={() => {
                          downloadDocumentsUnzip(type, data.id);
                        }}
                        className="min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px]"
                      >
                        <DownloadOutlined className="mr-2 mt-1" />
                        <p>Download Files</p>
                      </Button>
                    </div>
                  }
                  placement="bottom"
                  trigger="hover"
                  open={downloadPopOver}
                  onOpenChange={handleOpenChange}
                >
                  <Button
                    className=" mt-4 min-[768px]:text-[14px] max-[768px]:text-[12px]"
                    type="primary"
                  >
                    Download All Documents
                  </Button>
                </Popover>
              </div>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mb-1 mt-4">
            {dataDocuments !== undefined &&
              dataDocuments.length > 0 &&
              dataDocuments.map((doc, index) => {
                const key = Object.keys(doc)[0];
                const valueLength = doc[key].length;
                let words = key.split("_");
                for (let i = 0; i < words.length; i++) {
                  words[i] =
                    words[i].charAt(0).toUpperCase() + words[i].slice(1);
                }
                let result = words.join(" ");
                if (result.length <= 4) {
                  result = result.toUpperCase();
                }
                const shouldStartNewRow = index > 0 && index % 4 === 0;

                return (
                  <>
                    {shouldStartNewRow && (
                      <div style={{ flexBasis: "100%", height: 0 }}></div>
                    )}
                    <Col>
                      <div className="sm:w-2/2 lg:w-4/4 mt-1 flex py-2 w-[250px] px-2">
                        <img
                          style={{ width: "15px", height: "15px" }}
                          className="mr-3 mt-[2px]"
                          src={"/images/" + "additional_documents" + ".png"}
                        />
                        <div className="w-full flex">
                          <div className="text-[13px] font-[500] text-[#0D062D]">
                            {result === "Vehicle Overseas Log Card"
                              ? "V5/Overseas Logcard"
                              : result}
                          </div>
                        </div>
                      </div>
                      {doc[key].map((data) => {
                        let valType = false;
                        let imgType = "";
                        if (typeof data === "object") {
                          valType = true;
                          let popType = data.value.split(".").pop();
                          //console.log("popType", popType);
                          if (popType === "pdf") {
                            imgType = "pdf";
                          } else if (popType === "docx") {
                            imgType = "docx";
                          }
                        }
                        return (
                          <Fragment>
                            <div className="sm:w-2/2 lg:w-4/4 mt-1 flex border rounded py-2 w-full px-2">
                              {imgType === "pdf" ? (
                                <FilePdfOutlined className="pdfOutlineStyle" />
                              ) : imgType === "docx" ? (
                                <FileWordOutlined className="pdfOutlineStyle" />
                              ) : (
                                <img
                                  style={{ width: "50px", height: "50px" }}
                                  className="mr-3 mt-[2px]"
                                  src={
                                    valType
                                      ? IMAGE_BASE_URL + data.value
                                      : IMAGE_BASE_URL + data
                                  }
                                />
                              )}
                              <div className="w-full justify-between flex mt-4">
                                <div className="text-[13px] font-[500] text-[#0D062D] whitespace-nowrap truncate max-w-[150px]">
                                  {data.name}
                                </div>
                                <div>
                                  <div className="text-right">
                                    <img
                                      src="/images/document_download.png"
                                      alt="Download Document"
                                      className="max-w-xs cursor-pointer ml-auto"
                                      onClick={() => {
                                        setDocumentPreview(true);
                                        setDocumentUrl(data.value);
                                        fileType(data.value);
                                        // DownloadDocumentFile();
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="w-full flex justify-between items-center mt-1">
                              <p className="text-left font-lato text-[12px] text-[500] text-instruction-grey opacity-60 mt-1"></p>
                            </div>
                          </Fragment>
                        );
                      })}
                      <div></div>
                    </Col>
                  </>
                );
              })}
          </Row>
          {/* <Row gutter={[16, 16]} className='mt-[50px]'>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Button className='text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[14px] max-[768px]:text-[12px]'>
                SGCM Link
              </Button>
            </Col>
          </Row> */}
        </Fragment>
      )}
      {type == 'applicant' && (
        <Fragment>
          <div className="preview-details-head">
            <h1>Details</h1>
          </div>
          {ApplicantInfo?.typeinfo?.applicant_type === "Company" ? (
            <div className="preview-list-block">
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Applying As:</h3>
                  <p>{data.applicant_details?.typeinfo?.applicant_type}</p>
                </div>
                <div className="preview-list">
                  <h3>Company Name:</h3>
                  <p>{data.applicant_details?.company_name}</p>
                </div>
                <div className="preview-list">
                  <h3>UEN/ACRA No:</h3>
                  <p>{data.applicant_details?.uen_acra_no}</p>
                </div>
                <div className="preview-list">
                  <h3>UEN/ACRA No:</h3>
                  <p>{data.applicant_details?.uen_acra_no}</p>
                </div>
                <div className="preview-list">
                  <h3> Date of Incorporation:</h3>
                  <p>
                    {data.applicant_details?.date_of_incorporation !== "" &&
                      data.applicant_details?.date_of_incorporation !== null
                      ? dayjs(
                        data.applicant_details?.date_of_incorporation,
                        "YYY-MM-DD"
                      ).format("DD-MM-YYYY")
                      : ""}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>Mobile Number:</h3>
                  <p>{data.applicant_details?.mobile_no}</p>
                </div>
                <div className="preview-list">
                  <h3>Office Number:</h3>
                  <p>{data.applicant_details?.office}</p>
                </div>
                <div className="preview-list">
                  <h3>Email:</h3>
                  <p>{data.applicant_details?.email}</p>
                </div>
                <div className="preview-list">
                  <h3>Contact Person:</h3>
                  <p>{data.applicant_details?.name}</p>
                </div>
                <div className="preview-list">
                  <h3>Company Address:</h3>
                  <p>{data.applicant_details?.company_address}</p>
                </div>
                <div className="preview-list">
                  <h3>Postal Code:</h3>
                  <p>{data.applicant_details?.company_postal_code}</p>
                </div>
                <div className="preview-list">
                  <h3>Mailing Address:</h3>
                  <p>
                    {data.applicant_details?.mailing_company_address !== "" &&
                      data.applicant_details?.mailing_company_address != null
                      ? data.applicant_details?.mailing_company_address
                      : data.applicant_details?.company_address}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>Mailing Postal Code:</h3>
                  <p>
                    {ApplicantInfo?.mailing_company_postal_code !== "" &&
                      ApplicantInfo?.mailing_company_postal_code != null
                      ? ApplicantInfo?.mailing_company_postal_code
                      : ApplicantInfo?.company_postal_code}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="preview-list-block">
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Applying As:</h3>
                  <p>{data.applicant_details?.typeinfo?.applicant_type}</p>
                </div>
                <div className="preview-list">
                  <h3>Title:</h3>
                  <p>{data.applicant_details?.title}</p>
                </div>
                <div className="preview-list">
                  <h3>Name:</h3>
                  <p>
                    {data.applicant_details?.name
                      ? data.applicant_details?.name
                      : data.applicant_details?.company_name}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>NRIC:</h3>
                  <p>{data.applicant_details?.nric}</p>
                </div>
                <div className="preview-list">
                  <h3>Date of Birth:</h3>
                  <p>
                    {moment(data.applicant_details?.dob).format("DD-MM-YYYY")}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>Gender:</h3>
                  <p>
                    {data.applicant_details?.gender
                      ? data.applicant_details?.gender
                      : "-"}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>Race:</h3>
                  <p>{data.applicant_details?.race}</p>
                </div>
                <div className="preview-list">
                  <h3>Marital Status:</h3>
                  <p>{data.applicant_details?.marital_status}</p>
                </div>
                {data.applicant_details?.marital_status === "Married" && (
                  <div className="preview-list">
                    <h3>Name of Spouse:</h3>
                    <p>
                      {data.applicant_details?.name_of_spouse
                        ? data.applicant_details?.name_of_spouse
                        : "-"}
                    </p>
                  </div>
                )}
                <div className="preview-list">
                  <h3>Home No:</h3>
                  <p>
                    {data.applicant_details?.home_no
                      ? data.applicant_details?.home_no
                      : "-"}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>Mobile No:</h3>
                  <p>{data.applicant_details?.mobile_no}</p>
                </div>
                <div className="preview-list">
                  <h3>Office No:</h3>
                  <p>
                    {data.applicant_details?.office
                      ? data.applicant_details?.office
                      : "-"}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>Email:</h3>
                  <p>
                    {data.applicant_details?.email
                      ? data.applicant_details?.email
                      : "-"}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>Residence:</h3>
                  <p>{data.applicant_details?.residence_type}</p>
                </div>

                <div className="preview-list">
                  <h3>Address:</h3>
                  <p>

                    {data.applicant_details?.home_address
                      ? data.applicant_details?.home_address
                      : "-"}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>Postal Code:</h3>
                  <p>

                    {data.applicant_details?.postal_code
                      ? data.applicant_details?.postal_code
                      : "-"}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>Mailing Residence Type:</h3>
                  {/* <p>{data.applicant_details?.mailing_residence_type}</p> */}
                  <p>
                    {data.applicant_details?.home_address_same_as_mailing == 0
                      ? data.applicant_details?.mailing_residence_type
                      : data.applicant_details?.mailing_home_address}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>Mailing Address:</h3>
                  <p>

                    {data.applicant_details?.home_address_same_as_mailing == 1
                      ? data.applicant_details?.home_address
                      : data.applicant_details?.mailing_home_address}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>Mailing Postal Code:</h3>
                  <p>

                    {data.applicant_details?.home_address_same_as_mailing == 1
                      ? data.applicant_details?.postal_code
                      : data.applicant_details?.mailing_postal_code}
                  </p>
                </div>
                <div className="preview-list">
                  <h3>Employment:</h3>
                  <p>{data.applicant_employement_details?.employment_type}</p>
                </div>
                {ApplicantInfo?.typeinfo?.applicant_type ===
                  "Work Pass Holder(FIN)" ||
                  (ApplicantInfo?.typeinfo?.applicant_type ===
                    "Foreign Work Pass(Passport)" && (
                      <>
                        <div className="preview-list">
                          <h3>Nationality/Country:</h3>
                          <p>
                            {data.applicant_details?.nationality
                              ? data.applicant_details?.nationality
                              : "-"}
                          </p>
                        </div>
                        <div className="preview-list">
                          <h3>FIN No:</h3>
                          <p>{data.applicant_details?.fin_no}</p>
                        </div>
                        <div className="preview-list">
                          <h3> Passport No:</h3>
                          <p>{data.applicant_details?.passport_no}</p>
                        </div>
                        <div className="preview-list">
                          <h3>Passport Expiry:</h3>
                          <p>{data.applicant_details?.passport_expiry_date}</p>
                        </div>
                      </>
                    ))}
              </div>
            </div>
          )}

          {showMore &&
            data.applicant_employement_details &&
            data.applicant_employement_details?.employment_type !=
            "Unemployed" &&
            ApplicantInfo?.typeinfo?.applicant_type !== "Company" ? (
            <>
              <div className="preview-list-block">
                <div className="preview-list-group">
                  <div className="preview-list">
                    <h3>Occupation:</h3>
                    <p>
                      {EmploymentDetails?.occupation}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Income Type:</h3>
                    <p>
                      {data.applicant_employement_details?.finance_type
                        ? data.applicant_employement_details?.finance_type
                        : "-"}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Type of Industry:</h3>
                    <p>
                      {data.applicant_employement_details?.type_of_industry
                        ? data.applicant_employement_details?.type_of_industry
                        : "-"}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Monthly Income:</h3>
                    <p>
                      {data.applicant_employement_details?.monthly_income
                        ? " $ " +
                        data.applicant_employement_details?.monthly_income
                        : "-"}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Other Monthly Income:</h3>
                    <p>
                      {data.applicant_employement_details?.other_income
                        ? " $ " +
                        data.applicant_employement_details?.other_income
                        : "-"}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Length of Service:</h3>
                    <p>
                      {(data.applicant_employement_details
                        ?.service_duration_years &&
                        data.applicant_employement_details
                          ?.service_duration_years + " years ") +
                        (data.applicant_employement_details
                          ?.service_duration_months &&
                          data.applicant_employement_details
                            ?.service_duration_months + " months ")}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Employer Name:</h3>
                    <p>
                      {data.applicant_employement_details?.employer_name
                        ? data.applicant_employement_details?.employer_name
                        : "-"}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Employer Address:</h3>
                    <p>
                      {data.applicant_employement_details?.employer_address
                        ? data.applicant_employement_details?.employer_address
                        : "-"}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Employer Postal Code:</h3>
                    <p>
                      {data.applicant_employement_details?.employer_postal_code
                        ? data.applicant_employement_details?.employer_postal_code
                        : "-"}
                    </p>
                  </div>

                </div>
              </div>

              <div className="preview-list-block">
                <div className="preview-list-group">
                  <div className="preview-list">
                    <h3>Prev. Occupation:</h3>
                    <p>
                      {data.applicant_employement_details
                        ?.employer_previous_occupation
                        ? data.applicant_employement_details
                          ?.employer_previous_occupation
                        : "-"}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Prev. Length of Service:</h3>
                    <p>
                      {(data.applicant_employement_details
                        ?.employer_previous_experience_years &&
                        data.applicant_employement_details
                          ?.employer_previous_experience_years + " years ") +
                        (data.applicant_employement_details
                          ?.employer_previous_experience_months &&
                          data.applicant_employement_details
                            ?.employer_previous_experience_months +
                          " months ")}
                    </p>
                  </div>
                </div>
                <div className="preview-list-group">
                  <div className="preview-list">
                    <h3>Prev. Employer Name:</h3>
                    <p>
                      {data.applicant_employement_details
                        ?.employer_previous_name
                        ? data.applicant_employement_details
                          ?.employer_previous_name
                        : "-"}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Prev. Employer Address:</h3>
                    <p>
                      {data.applicant_employement_details
                        ?.employer_previous_address
                        ? data.applicant_employement_details
                          ?.employer_previous_address
                        : "-"}
                    </p>
                  </div>
                  <div className="preview-list">
                    <h3>Prev. Employer Postal Code:</h3>
                    <p>
                      {data.applicant_employement_details
                        ?.employer_previous_postal_code
                        ? data.applicant_employement_details
                          ?.employer_previous_postal_code
                        : "-"}
                    </p>
                  </div>

                </div>
              </div>
              <div className="text-center">
                <Button
                  onClick={() => {
                    setShowMore(false);
                  }}
                  className="text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[14px] max-[768px]:text-[12px] mt-2"
                >
                  See Less Details
                </Button>
              </div>
            </>
          ) : null}
          {!showMore &&
            data.applicant_employement_details?.employment_type !==
            "Unemployed" &&
            ApplicantInfo?.typeinfo?.applicant_type !== "Company" && (
              <div className="text-center mb-2">
                <Button
                  onClick={() => {
                    setShowMore(true);
                  }}
                  className="text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[14px] max-[768px]:text-[12px] mt-2"
                >
                  Show More Details
                </Button>
              </div>
            )}
          <Row gutter={[24, 0]}>
            <Col xs={24} sm={24} md={12} lg={12} className="">
              <p className="mt-5 text-[15px] font-[600]">
                Document(s) Uploaded
              </p>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} className="text-right">
              <div className="justify-between items-center mb-2">
                <Popover
                  content={
                    <div>
                      <Button
                        type="primary"
                        onClick={() => {
                          downloadDocuments(type, data.id);
                        }}
                        className="min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px] mb-2"
                      >
                        <FileZipOutlined className="mr-2 mt-1" />
                        <p>Download Zip</p>
                      </Button>
                      <Button
                        type="primary"
                        onClick={() => {
                          downloadDocumentsUnzip(type, data.id);
                        }}
                        className="min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px]"
                      >
                        <DownloadOutlined className="mr-2 mt-1" />
                        <p>Download Files</p>
                      </Button>
                    </div>
                  }
                  placement="bottom"
                  trigger="hover"
                  open={downloadPopOver}
                  onOpenChange={handleOpenChange}
                >
                  <Button
                    className=" mt-4 min-[768px]:text-[14px] max-[768px]:text-[12px]"
                    type="primary"
                  >
                    Download All Documents
                  </Button>
                </Popover>
              </div>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className="mb-1 mt-4">
            {dataDocuments !== undefined &&
              dataDocuments.length > 0 &&
              dataDocuments.map((doc, index) => {
                const key = Object.keys(doc)[0];
                const valueLength = doc[key].length;
                let words = key.split("_");
                for (let i = 0; i < words.length; i++) {
                  words[i] =
                    words[i].charAt(0).toUpperCase() + words[i].slice(1);
                }
                let result = words.join(" ");
                if (result.length <= 4) {
                  result = result.toUpperCase();
                }
                // Determine if a new row should start
                const shouldStartNewRow = index > 0 && index % 4 === 0;

                return (
                  <>
                    {shouldStartNewRow && (
                      <div style={{ flexBasis: "100%", height: 0 }}></div>
                    )}
                    <Col>
                      <div className="sm:w-2/2 lg:w-4/4 mt-1 flex py-2 w-[250px] px-2">
                        <img
                          style={{ width: "15px", height: "15px" }}
                          className="mr-3 mt-[2px]"
                          src={"/images/" + "additional_documents" + ".png"}
                        />
                        <div className="w-full flex">
                          <div className="text-[13px] font-[500] text-[#0D062D]">
                            {result === "NAO" ? "NOA" : result}
                          </div>
                        </div>
                      </div>
                      {doc[key].map((data) => {
                        let valType = false;
                        let imgType = "";
                        if (typeof data === "object") {
                          valType = true;
                          let popType = data.value.split(".").pop();
                          if (popType === "pdf") {
                            imgType = "pdf";
                          } else if (popType === "docx") {
                            imgType = "docx";
                          }
                        }
                        return (
                          <Fragment>
                            <div className="sm:w-2/2 lg:w-4/4 mt-1 flex border rounded py-2 w-full px-2">
                              {imgType === "pdf" ? (
                                <FilePdfOutlined className="pdfOutlineStyle" />
                              ) : imgType === "docx" ? (
                                <FileWordOutlined className="pdfOutlineStyle" />
                              ) : (
                                <img
                                  style={{ width: "50px", height: "50px" }}
                                  className="mr-3 mt-[2px]"
                                  src={
                                    valType
                                      ? IMAGE_BASE_URL + data.value
                                      : IMAGE_BASE_URL + data
                                  }
                                />
                              )}
                              <div className="w-full flex justify-between mt-4">
                                <div className="text-[13px] font-[500] text-[#0D062D] whitespace-nowrap truncate max-w-[150px]">
                                  {valType
                                    ? data.name
                                    : data.split("/").pop()}
                                </div>
                                <div>
                                  <div className="text-right">
                                    <img
                                      src="/images/document_download.png"
                                      alt="Download Document"
                                      className="max-w-xs cursor-pointer ml-auto"
                                      onClick={() => {
                                        setDocumentPreview(true);
                                        setDocumentUrl(
                                          valType ? data.value : data
                                        );
                                        fileType(valType ? data.value : data);
                                        // DownloadDocumentFile();
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="w-full flex justify-between items-center mt-1">
                              <p className="text-left font-lato text-[12px] text-[500] text-instruction-grey opacity-60 mt-1"></p>
                            </div>
                          </Fragment>
                        );
                      })}
                      <div></div>
                    </Col>
                  </>
                );
              })}
          </Row>
        </Fragment>
      )}
      {type == 'guarantor' && (
        <Fragment>
          <div className='guarantor_tb_sec'>
            <p className='text-[16px] font-[700] pb-[15px]'>Notification(s)</p>
            <NotificationCarousel data={data.agent_notifications} />
            <Tabs
              className='mt-[20px]'
              defaultActiveKey='1'
              onChange={(value) => {
                setSelectedGuarantorTab(value);
              }}
              items={GuarantorItems}
            />
          </div>
        </Fragment>
      )}
      {type == 'loan' && (
        <Fragment>
          {/* {console.log(loanTabDetails)} */}
          <LoanSwitchBox
            handler={setLoanDetailName}
            tabs={[
              { name: 'All', dataKey: 'All' },
              { name: 'Bank', dataKey: 'Bank' },
              {
                name: 'Financial Institution',
                dataKey: 'Financial_Institution',
              },
              { name: 'In-House', dataKey: 'In-House' },
            ]}
          />
          {loanTabDetails.length > 0 ? (
            <div className='loan-acc-section'>
              <Collapse
                collapsible='icon'
                className='loan-collpase'
                defaultActiveKey={['1', '2', '3', '4', '5', '6', '7']}
                expandIconPosition={'end'}
                expandIcon={({ isActive }) => (
                  <div className='icon-container'>
                    <span
                      className={`loan-acc-btn ${isActive ? 'down-arrow' : ''}`}
                    >
                      <CircleArrow />
                    </span>
                  </div>
                )}
                items={loanTabDetails}
              />
            </div>
          ) : (
            <div
              className='"whitespace-nowrap px-5 py-4 text-center  text-[13px] w-full'
              colSpan={11}
            >
              {' '}
              No Products Available
            </div>
          )}
        </Fragment>
      )}
      {type == 'dealer' && data?.user_type == 1 && (
        <div className='border rounded-xl mx-3 p-3 my-3'>
          {/* {console.log("DEALERDATD", data)} */}
          <Row gutter={[16, 16]} className=''>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <p className='detail-label mb-3'>Dealer:</p>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={12}
                  className='text-[12px] font-[500]'
                >
                  <p>{data.dealer_info?.name !== undefined ? data.dealer_info?.name : "-"}</p>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <p className='detail-label mb-3'>Office No.:</p>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={12}
                  className='text-[12px]  font-[500]'
                >
                  -
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <p className='detail-label mb-3'>Point of Contact:</p>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={12}
                  className='text-[12px]  font-[500]'
                >
                  {data.dealer_info?.contacts[0]?.name}
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <p className='detail-label mb-3'>Mobile No.:</p>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={12}
                  className='text-[12px]  font-[500]'
                >
                  {data.dealer_info?.phoneNumber !== undefined ? data.dealer_info?.countryCode +
                    ' ' +
                    data.dealer_info?.phoneNumber : "-"}
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      )}
      {type == 'disbursement' && (
        <Fragment>
          <Row gutter={[16, 16]} className='mb-1 mt-4'>
            {dataDocuments !== undefined && dataDocuments.length > 0 ? (
              dataDocuments.map((doc, index) => {
                // console.log(doc);
                const key = Object.keys(doc)[0];
                const valueLength = doc[key].length;
                let words = key.split('_');
                for (let i = 0; i < words.length; i++) {
                  words[i] =
                    words[i].charAt(0).toUpperCase() + words[i].slice(1);
                }
                let result = words.join(' ');
                if (result.length <= 4) {
                  result = result.toUpperCase();
                }
                // Determine if a new row should start
                const shouldStartNewRow = index > 0 && index % 4 === 0;

                return (
                  <>
                    {shouldStartNewRow && (
                      <div style={{ flexBasis: '100%', height: 0 }}></div>
                    )}
                    <Col xs={24} sm={24} md={6} lg={6} className=''>
                      <div className='sm:w-2/2 lg:w-4/4 mt-1 flex py-2 w-[250px] px-2'>
                        <img
                          style={{ width: '15px', height: '15px' }}
                          className='mr-3 mt-[2px]'
                          src={'/images/' + 'additional_documents' + '.png'}
                        />
                        <div className='w-full flex'>
                          <div className='text-[13px] font-[500] text-[#0D062D]'>
                            {result === 'NAO' ? 'NOA' : result}
                          </div>
                        </div>
                      </div>
                      {/* {console.log("DISBURSEMNETCDOCCS", doc[key])} */}
                      {doc[key].map((data) => {
                        let valType = false;
                        let imgType = '';
                        if (typeof data === 'object') {
                          valType = true;
                          let popType = data.value.split('.').pop();
                          if (popType === 'pdf') {
                            imgType = 'pdf';
                          } else if (popType === 'docx') {
                            imgType = 'docx';
                          }
                        }
                        return (
                          <Fragment>
                            <div className='sm:w-2/2 lg:w-4/4 mt-1 flex border rounded py-2 w-full px-2'>
                              {imgType === 'pdf' ? (
                                <FilePdfOutlined className='pdfOutlineStyle' />
                              ) : imgType === 'docx' ? (
                                <FileWordOutlined className='pdfOutlineStyle' />
                              ) : (
                                <img
                                  style={{ width: '50px', height: '50px' }}
                                  className='mr-3 mt-[2px]'
                                  src={
                                    valType
                                      ? IMAGE_BASE_URL + data.value
                                      : IMAGE_BASE_URL + data
                                  }
                                />
                              )}
                              <div className='w-full flex justify-between mt-4'>
                                <div className='text-[13px] font-[500] text-[#0D062D] whitespace-nowrap truncate max-w-[150px]'>
                                  {valType ? data.name : data.split('/').pop()}
                                </div>
                                <div>
                                  <div className='text-right'>
                                    <img
                                      src='/images/document_download.png'
                                      alt='Download Document'
                                      className='max-w-xs cursor-pointer ml-auto'
                                      onClick={() => {
                                        setDocumentPreview(true);
                                        setDocumentUrl(
                                          valType ? data.value : data
                                        );
                                        fileType(valType ? data.value : data);
                                        // DownloadDocumentFile();
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className='w-full flex justify-between items-center mt-1'>
                              <p className='text-left font-lato text-[12px] text-[500] text-instruction-grey opacity-60 mt-1'></p>
                            </div>
                          </Fragment>
                        );
                      })}
                      <div></div>
                    </Col>
                  </>
                );
              })
            ) : (
              <div className='text-center w-full'>No Disbursement Made</div>
            )}
          </Row>
          {data.disbursementinfo &&
            disEditMode &&
            pagePermission?.update_permission == 1 && (
              <div>
                <div className='flex gap-[15px_30px] flex-wrap max-w-[900px] my-[30px]'>
                  <div className='flex-[1_1_200px]'>
                    <label className='text-[#787486] text-[13px] mb-[4px]'>
                      Date of Disbursement
                      <Popover content={'Coming soon'} className='mt-[-2px]'>
                        <img
                          src='/images/fi_info.svg'
                          alt='info'
                          className='inline-block ml-[8px] cursor-pointer'
                        />
                      </Popover>
                    </label>
                    <div>
                      <DatePicker
                        placeholder='DD-MM-YYYY'
                        format={'DD-MM-YYYY'}
                        className={`py-[8px]`}
                        status={disErrors?.date_disb ? 'error' : null}
                        value={disbDate ? dayjs(disbDate) : null}
                        onChange={(date) => {
                          setDisbDate(date ? date.valueOf() : null);
                        }}
                      />
                    </div>
                  </div>
                  <div className='flex-[1_1_200px]'>
                    <label className='text-[#787486] text-[13px] mb-[4px]'>
                      Disbursement Proof
                    </label>
                    <Modal
                      open={previewOpen}
                      title={previewTitle}
                      centered
                      footer={null}
                      onCancel={() => setPreviewOpen(false)}
                    >
                      {previewType === 'img' ? (
                        <img
                          alt='example'
                          style={{
                            width: '100%',
                          }}
                          src={previewImage}
                        />
                      ) : (
                        <iframe
                          src={previewImage}
                          className='w-full'
                          height={400}
                        />
                      )}
                    </Modal>
                    <Upload
                      listType='picture'
                      maxCount={1}
                      customRequest={customUploadRequest}
                      onPreview={handlePreview}
                      fileList={fileList}
                      onRemove={onRemoveRequest}
                      onChange={onImageChange}
                      accept='.png,.jpeg,.jpg,.docx,.doc,.pdf'
                    >
                      <div className='grid grid-cols-2 gap-4 w-full mt-5'>
                        <div className='py-4 mt-[-20px]'>
                          {' '}
                          <p className='text-left font-lato text-[13px] text-[400] text-instruction-grey opacity-60'>
                            Max 1 File{' '}
                          </p>
                        </div>
                        <div className='p-4  mt-[-27px] upload-btn'>
                          <Button className='border-0 shadow-none text-step-color-active'>
                            <div className='flex'>
                              <UploadOutlined className='mt-1 mr-2' />
                              <span>Upload</span>
                            </div>
                          </Button>
                        </div>
                      </div>
                    </Upload>
                  </div>
                  <div className='flex-[1_1_200px]'>
                    <label className='text-[#787486] text-[13px] mb-[4px]'>
                      Remarks (optional)
                    </label>
                    <Input
                      value={disbRemark}
                      onChange={(e) => setDisbRemark(e.target.value)}
                      className='h-[40px]'
                    />
                  </div>
                </div>
                <div>
                  <Button
                    type='primary'
                    className={`bg-[#055FFB!important] font-[500] min-w-[125px] min-h-[40px]`}
                    onClick={async () => {
                      setDisbErrors({
                        ...disErrors,
                        date_disb: false,
                      });
                      if (disbDate === '' || disbDate === null) {
                        setDisbErrors({
                          ...disErrors,
                          date_disb: true,
                        });
                      } else {
                        const disbData = data.disbursementinfo;
                        const tokenId =
                          localStorage.getItem('agentModuleToken');
                        const agentDisbDoc = JSON.parse(
                          localStorage.getItem('agent_disbursement_ack_doc')
                        );
                        const resp = await axios.put(
                          `loan/application/disbursement/approval/${disbData.id}`,
                          {
                            transaction_history: disbData.transaction_history,
                            vehicle_information: disbData.vehicle_information,
                            vehicle_acknowledgement:
                              disbData.vehicle_acknowledgement,
                            insurance_certificate:
                              disbData.insurance_certificate,
                            number_retention_letter:
                              disbData.number_retention_letter,
                            application_product: disbData.application_product,
                            remarks: disbRemark,
                            disbursement_date:
                              dayjs(disbDate).format('YYYY-MM-DD'),
                            agent_disbursement_ack_doc: agentDisbDoc
                              ? agentDisbDoc
                              : [],
                          },
                          {
                            headers: {
                              Authorization: `Bearer ${tokenId}`,
                            },
                          }
                        );
                        if (resp) {
                          toast.success('Updated Successfully!!!');
                          reloadData();
                        }
                      }
                    }}
                  >
                    Confirm
                  </Button>
                  <Button
                    type='default'
                    className={`font-[500] min-w-[125px] min-h-[41px] ml-[20px]`}
                    onClick={() => setDisEditMode(false)}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            )}
          {data.disbursementinfo &&
            !disEditMode &&
            pagePermission?.update_permission == 1 && (
              <div>
                <div className='flex gap-[15px_30px] flex-wrap max-w-[900px] my-[30px]'>
                  <div className='flex-[1_1_200px]'>
                    <label className='text-[#787486] text-[13px]'>
                      Date of Disbursement
                      <Popover content={'Coming soon'} className='mt-[-2px]'>
                        <img
                          src='/images/fi_info.svg'
                          alt='info'
                          className='inline-block ml-[8px] cursor-pointer'
                        />
                      </Popover>
                    </label>
                    <p className='font-[500] text-[13px]'>
                      {dayjs(data.disbursementinfo.disbursement_date).format(
                        'DD-MM-YYYY'
                      )}
                    </p>
                  </div>
                  <div className='flex-[1_1_300px]'>
                    <label className='text-[#787486] text-[13px]'>
                      Disbursement Document
                    </label>

                    {data.disbursementinfo !== null ? (
                      <Fragment>
                        {data.disbursementinfo?.agent_disbursement_ack_doc !== undefined &&
                          data.disbursementinfo?.agent_disbursement_ack_doc?.map((doc, index) => {
                            let valType = false;
                            let imgType = '';
                            if (typeof doc === 'object') {
                              {
                                // console.log("LOCALDOCUMHIET", doc)
                              }
                              valType = true;
                              let popType = '';
                              if (doc?.name?.includes('.pdf')) {
                                imgType = 'pdf';
                              } else if (doc?.name?.includes('.docx')) {
                                imgType = 'docx';
                              }
                            }
                            return (
                              <>
                                <div>
                                  <Fragment>
                                    <div className='sm:w-2/2 lg:w-4/4 mt-1 flex border rounded py-2 w-full px-2'>
                                      {imgType === 'pdf' ? (
                                        <FilePdfOutlined className='pdfOutlineStyle' />
                                      ) : imgType === 'docx' ? (
                                        <FileWordOutlined className='pdfOutlineStyle' />
                                      ) : (
                                        <img
                                          style={{
                                            width: '50px',
                                            height: '50px',
                                          }}
                                          className='mr-3 mt-[2px]'
                                          src={
                                            valType
                                              ? IMAGE_BASE_URL + doc.value
                                              : IMAGE_BASE_URL + doc
                                          }
                                        />
                                      )}
                                      <div className='w-full flex justify-between mt-4'>
                                        <div className='text-[13px] font-[500] text-[#0D062D] whitespace-nowrap truncate max-w-[180px]'>
                                          {valType
                                            ? doc.name
                                            : doc.split('/').pop()}
                                        </div>
                                        <div>
                                          <div className='text-right'>
                                            <img
                                              src='/images/document_download.png'
                                              alt='Download Document'
                                              className='max-w-xs cursor-pointer ml-auto'
                                              onClick={() => {
                                                setDocumentPreview(true);
                                                setDocumentUrl(
                                                  valType ? doc.value : doc
                                                );
                                                fileType(
                                                  valType ? doc.value : doc
                                                );
                                                // DownloadDocumentFile();
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='w-full flex justify-between items-center mt-1'>
                                      <p className='text-left font-lato text-[12px] text-[500] text-instruction-grey opacity-60 mt-1'></p>
                                    </div>
                                  </Fragment>
                                </div>
                              </>
                            );
                          })}
                      </Fragment>
                    ) : (
                      <p className='font-[500] text-[13px]'>N/A</p>
                    )}
                  </div>
                  <div className='flex-[1_1_200px]'>
                    <label className='text-[#787486] text-[13px]'>
                      Remarks
                      <Popover
                        content={
                          'The remarks will be visible to the dealer as well.'
                        }
                        className='mt-[-2px]'
                      >
                        <img
                          src='/images/fi_info.svg'
                          alt='info'
                          className='inline-block ml-[8px] cursor-pointer'
                        />
                      </Popover>
                    </label>
                    <p className='font-[500] text-[13px]'>
                      {data.disbursementinfo.remarks
                        ? data.disbursementinfo.remarks
                        : 'N/A'}
                    </p>
                  </div>
                </div>
                <div>
                  {!isDibursed && (
                    <Button
                      type='primary'
                      className={`bg-[#055FFB!important] font-[500] min-w-[125px] min-h-[40px]`}
                      onClick={() => {
                        setDisEditMode(true);
                        setDisbErrors({
                          ...disErrors,
                          date_disb: false,
                        });
                      }}
                    >
                      Edit
                    </Button>
                  )}
                </div>
              </div>
            )}
        </Fragment>
      )}
      <DocumentPreview
        open={documentPreview}
        close={() => {
          setDocumentPreview(false);
        }}
        title={type.charAt(0).toUpperCase() + type.slice(1) + 'Document'}
        url={documentUrl}
        type={fileDocumentType}
      />
    </div>
  );
};

export default CaseTabDetails;
